import {Component, input} from '@angular/core';
import {KeyValuePipe, NgClass} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CdkAccordion, CdkAccordionItem} from "@angular/cdk/accordion";

@Component({
  selector: 'app-mer-accordion',
  imports: [
    KeyValuePipe,
    ReactiveFormsModule,
    FormsModule,
    NgClass,
    CdkAccordion,
    CdkAccordionItem
  ],
  templateUrl: './mer-accordion.component.html',
  styleUrl: './mer-accordion.component.scss'
})
export class MerAccordionComponent {

  subscriptionName = input.required<string>()
  data = input<Map<string, Object>>()

  fullExtended = false;

  toggleAll(accordionMain: CdkAccordion) {
    if (this.fullExtended) {
      accordionMain.closeAll()
    } else {
      accordionMain.openAll()
    }

    this.fullExtended = !this.fullExtended;
  }
}
